import React from 'react';
import s from './ActionBarItemContentWrapper.scss';

interface Props {}

/**
 * Provides styling for the content of our `ActionBar` item components.
 *
 * See `ActionBarButton` for examples.
 */
const ActionBarItemContentWrapper: React.FC<React.PropsWithChildren<Props>> = ({ children }) => {
  return <div className={s['root']}>{children}</div>;
};
ActionBarItemContentWrapper.displayName = 'ActionBarItemContentWrapper';

export default ActionBarItemContentWrapper;
